<label *ngIf="outerLabel"> {{ outerLabel }} </label>
<mat-form-field appearance="outline" [subscriptSizing]="subscriptSizing">
  <mat-label *ngIf="label"> {{ label }} </mat-label>
  <mat-select
    [formControl]="modelCtrl"
    [multiple]="multiple"
    [required]="required"
    [errorStateMatcher]="errorStateMatcher"
    [panelWidth]="panelWidth"
  >
    <mat-select-trigger>
      {{ selectedOptionDisplayValue }}
    </mat-select-trigger>

    <div *ngIf="canSearch" class="search-option">
      <mat-form-field appearance="outline" [subscriptSizing]="subscriptSizing">
        <input
          #searchInput
          matInput
          type="text"
          tabindex="0"
          placeholder="Search"
          autocomplete="off"
          [formControl]="searchCtrl"
          (keydown)="$event.stopPropagation()"
        />
      </mat-form-field>
    </div>

    <ng-container *ngFor="let option of filteredOptions">
      <mat-optgroup class="profet-select-option-group" [label]="option.displayValue ?? ''" *ngIf="option.children">
        <mat-option
          class="profet-select-option"
          color="primary"
          *ngFor="let child of option.children"
          [value]="child.key"
          [disabled]="shouldDisableOption(child.key)"
        >
          <ng-container *ngTemplateOutlet="optionTemplate; context: { option: child }" />
        </mat-option>
      </mat-optgroup>

      <mat-option
        class="profet-select-option"
        color="primary"
        *ngIf="!option.children"
        [value]="option.key"
        [disabled]="shouldDisableOption(option.key)"
      >
        <ng-container *ngTemplateOutlet="optionTemplate; context: { option: option }" />
      </mat-option>
    </ng-container>

    <span *ngIf="!filteredOptions?.length" class="no-results"> Not Found </span>
  </mat-select>
  <app-progress-spinner *ngIf="inProgress" [inline]="true" [size]="16"></app-progress-spinner>
  <mat-error *ngIf="required && modelCtrl.invalid && modelCtrl.touched && modelCtrl.dirty">
    Please select a value
  </mat-error>
</mat-form-field>

<!-- Option Item Template -->
<ng-template #optionTemplate let-option="option">
  <div class="select-option-prefix">
    {{ option.prefix }}
  </div>

  <div class="select-option-content">
    <span>
      {{ option.displayValue }}
    </span>
    <span class="subtext" *ngIf="option.subText">
      {{ option.subText }}
    </span>
  </div>

  <div class="select-option-suffix">
    {{ option.suffix }}
  </div>
</ng-template>
